export default "__VITE_ASSET__gkkuVCYq__"